import { Injectable } from '@angular/core';
import { SigningServiceHttp } from '../signing-service';

@Injectable({
    providedIn: 'root'
})
export class SigningSidebarService {

    constructor(private http: SigningServiceHttp) {
    }

    /**
     * get the document participants
     * @param role_id
     * @param document_id
     * @returns Promiss
     */
    getParticipants(role_id: number, document_id: number) {
        return this.http.get(`sign-document/${role_id}/${document_id}/participants`);
    }
}
